import { useEffect } from "react";
import ImageSlider from "../components/ImageSlider";
import { getGanjiToday, getDate } from "../util";
import { isIOS } from "react-device-detect";
// import TypingMain from "../components/TypingMain";
import { useSearchParams } from "react-router-dom";
import { useGPTStore } from "../store/useGPT";
import TypingMain from "../components/TypingMain";

const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

function MainPage() {
  const [searchParams] = useSearchParams();
  const handleLogin = () => {
    window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code`;
  };

  const { trackEvent } = useGPTStore();

  useEffect(() => {
    const trkId = searchParams.get("trkId");
    if (trkId) {
      localStorage.setItem("trkId", trkId);
    }

    if (!trkId) {
      localStorage.removeItem("trkId");
    }

    trackEvent(trkId ? trkId : "");
  }, [searchParams, trackEvent]);

  useEffect(() => {
    const updateMainStyle = () => {
      const mainElement = document.querySelector(".main_container main");
      if (mainElement instanceof HTMLElement) {
        // isKakaoOS가 true면 카카오 OS, isIOS가 true면 iOS 기기
        const isKakaoOS = navigator.userAgent.toLowerCase().includes("kakao");
        let additionalPadding = 0;

        if (isIOS && !isKakaoOS) {
          additionalPadding = 100; // iOS 기기일 때
        } else if (isIOS && isKakaoOS) {
          additionalPadding = 40; // 카카오 OS일 때
        }

        mainElement.style.paddingBottom = `${additionalPadding}px`;
      }
    };

    updateMainStyle();
    window.addEventListener("resize", updateMainStyle);
    return () => window.removeEventListener("resize", updateMainStyle);
  }, []);

  return (
    <div className="main_container">
      <main className="landing">
        <ImageSlider />
        {/* <div className="moving_img"></div> */}
        <div className="date">{getDate().full}</div>
        <div className="date-hanja">{getGanjiToday()}</div>

        <div className="title">명리학을 기반으로 분석한</div>
        <div className="title highlight">오늘의 운세는?</div>

        <TypingMain />

        <div className="button_description">
          <span
            className="highlight"
            style={{ color: "#9c2020", fontWeight: "bold" }}
          >
            무료운세 확인하고
          </span>{" "}
          쿠폰받기
        </div>

        <div className="kakao_button" onClick={handleLogin}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            style={{ width: "1em", height: "1em", marginRight: "8px" }}
          >
            {/* !Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free */}
            <path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3.7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z" />
          </svg>
          카카오톡으로 3초만에 시작하기
        </div>

        <a
          href="https://volcano-ixora-b68.notion.site/d6387521449d4db8bc95487a4e8ee28e"
          target="_blank"
          style={{
            display: "inline-block",
            fontSize: 12,
            marginTop: 16,
            color: "#bbbbbb",
            borderBottom: "1px solid #bbbbbb",
          }}
          rel="noreferrer"
        >
          개인정보처리방침
        </a>
      </main>
    </div>
  );
}

export default MainPage;
